<template>
  <div>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="getall_requirement"
    >
      <el-table-column label="Name" min-width="140px" prop="name" sortable>
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.firstName
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Service Required" width="200" class="">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.serviceReq
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column
        label="Description"
        min-width="200px"
        prop="description"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black" v-html="row.description"></span>
        </template>
      </el-table-column>

      <el-table-column label="Date" min-width="140px" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            formattedDate(row.date)
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Time" width="190">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{ row.time }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Service Required" min-width="190px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.serviceReq
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column> -->
      <el-table-column label="Session Type" min-width="190px">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-medium name mb-0 text-sm">{{
                row.serviceType
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="150px" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium" v-if="row.status">{{
            row.status
          }}</span>
          <b-button
            v-else
            variant="success"
            class="btn-sm"
            @click="handleReq(row)"
            >Accept</b-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import { mapState } from "vuex";
import reqtable from "../../../../volunteer-view/layouts/components/reqtable";

export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      reqtable,
    };
  },
  methods: {
    init() {
      // console.log(this.getall_requirement);
    },
    formattedDate(dateData) {
      const date = new Date(dateData);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      return formattedDate;
    },
    async handleReq(row) {
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("respitecare/editrequirement", {
          _id: row._id,
          status: "Accept",
        });
        if (data.code == 200) {
          await this.$store.dispatch("respitecare/get_allrequirement");

          let bookingPayload = {
            volunteerId: this.get_volunteerbyuserId[0]._id,
            date: row.date,
            time: row.time,
            userId: row.userId._id,
            price: this.get_volunteerbyuserId[0].price,
            session: row.serviceType,
            description: row.description,
            state: row.state,
            address: row.address,
            city: row.city,
            pincode: parseInt(row.pincode),
          };

          let bookingData = await this.$store.dispatch(
            "respitecare/createbooking",
            bookingPayload
          );

          if (bookingData) {
            let emailPayload = {
              email: row.userId.email,
              firstname: this.get_volunteerbyuserId[0].userId.firstname,
              lastname: this.get_volunteerbyuserId[0].userId.lastname,
              date: this.formattedDate(row.date),
              time: row.time,
            };
            let bookingEmail = await this.$store.dispatch(
              "respitecare/email_bookingsession",
              emailPayload
            );
            // console.log(bookingEmail);
          }

          await this.$store.dispatch("respitecare/get_allbookingcounts", {
            volunteerId: this.get_volunteerbyuserId[0]._id,
          });
        }

        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("respitecare", {
      getall_requirement: "getall_requirement",
    }),
    ...mapState("respitecare", {
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
